// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PDEw","content":"styles_content__1g0cG","tableWrap":"styles_tableWrap__1RfVX"};